import { Box, Skeleton } from '@factorialco/deprecated-design-system'
import { OneModal } from '@factorialco/f0-react/dist/experimental'

export const PrejoinSkeleton = () => {
  return (
    <OneModal isOpen onClose={() => {}}>
      <OneModal.Content>
        <Box
          width="full"
          height="s400"
          position="relative"
          padding="s16"
          alignItems="center"
          justifyContent="center"
        >
          <Skeleton isLoading height="full" />

          <Box width="full" gap="s12" alignItems="center" paddingTop="s16">
            <Box style={{ width: '100px' }} flexDirection="row" gap="s12">
              <Skeleton isLoading height="s40" />
              <Skeleton isLoading height="s40" />
            </Box>
            <Box width="full" flexDirection="row" gap="s12">
              <Skeleton isLoading height="s32" />
              <Skeleton isLoading height="s32" />
              <Skeleton isLoading height="s32" />
              <Skeleton isLoading height="s32" />
            </Box>
          </Box>
        </Box>
      </OneModal.Content>
    </OneModal>
  )
}
